import * as React from "react";
import {Icon, IConcreteIcon} from "../Icon";

export const UnknownIcon = ({style}: IConcreteIcon) => <Icon file="/icons/payment_methods/unknown.svg" style={style} />;
